export const settings = {
  state: {
    settings: {},
    widgetSettings: '',
    pagination: {
      page: 1,
      rowsPerPage: 25 ,// -1 for All",
    }
  },
  mutations: {
    'SET_SETTINGS' (state , settings){
      state.settings = settings
    },
    'SET_WIDGET_SETTINGS' (state, widgetSettings) {
      state.widgetSettings = widgetSettings
    },
    'SET_TABLES_NUMBER_OF_ROWS' (state,tablesNumberOfRows) {
      state.pagination.rowsPerPage = parseInt(tablesNumberOfRows)
    }
  },
  actions: {
    setSettings({commit},settings){
      commit('SET_SETTINGS',settings)
    },
    setWidgetSettings({commit},widgetSettings) {
      commit('SET_WIDGET_SETTINGS',widgetSettings)
    },
    setTableNumberOfRows({commit},tablesNumberOfRows) {
      commit('SET_TABLES_NUMBER_OF_ROWS',tablesNumberOfRows)
      localStorage.setItem('tablesNumberOfRows', tablesNumberOfRows)
    }
  }
}
